import { combineReducers } from 'redux';

import * as types from 'constants/ActionTypes';
import loading from 'modules/global/reducers/generic.loading';

/**
 * @typedef {{
 *  loading: {
 *     deposit: boolean,
 *     retrieve: boolean,
 *  }
 *  previewing: boolean,
 * }} DealerConfigReducer
 */

export default combineReducers({
  loading: combineReducers({
    deposit: loading(types.DEPOSIT_PREVIEW),
    retrieve: loading(types.PICKUP_PREVIEW),
  }),
});
